// Free sample excerpts for each book. Keyed by a lowercase fragment of the book title.
// The owner can replace any of these with the real opening chapter — just edit the text.
export const EXCERPTS = [
  {
    match: "pioneering",
    text: "Every business that lasts begins the same way: with a decision made before the world believes in it. In these pages we will walk through what it means to build in today's world — where artificial intelligence is not a threat to your dream, but a tool in your hands. You do not need permission to begin. You need a plan, a work ethic, and the courage to start before you feel ready.",
  },
  {
    match: "black family",
    text: "A family is the first classroom, the first boardroom, and the first church. Before we can rebuild our communities, we must be honest about what happened at our own kitchen tables. This book is an awakening — not to shame anyone, but to remind us of the strength we have always carried and the future our children deserve to inherit.",
  },
  {
    match: "dark angel",
    text: "She did not come to destroy. She came to reveal. Every city has its shadows, and every shadow hides something the daylight was afraid to say out loud. When the Dark Angel walks into the story, nothing stays hidden — not the truth, and certainly not the past.",
  },
  {
    match: "algebra made easy",
    text: "Algebra is not a wall. It is a door — and this book is the key. We will take every problem apart slowly, in plain language, until you see what I see: patterns, not puzzles. By the time you finish these pages, you will not just solve equations. You will understand them.",
  },
  {
    match: "nursing algebra",
    text: "In nursing, math is never just math. A dosage calculation is a patient's safety in your hands. This book takes you through every conversion, every formula, and every real clinical scenario step by step — so that when the moment comes, your hands are steady and your numbers are right.",
  },
  {
    match: "unbreakable",
    text: "Sixty is not the end of the story. It is the chapter where experience finally meets opportunity. Your body can grow stronger, your mind sharper, and your purpose clearer than at any point in your life. Unbreakable is not about denying your years — it is about demanding more from them.",
  },
  {
    match: "martin luther king",
    text: "A legacy is not what we remember. It is what we continue. Dr. King's dream was never meant to be a monument we visit once a year — it was meant to be a blueprint we build from every single day. This book traces the man, the movement, and the unfinished work he placed in our hands.",
  },
  {
    match: "diabetes",
    text: "Diabetes does not begin in the bloodstream. It begins in habits passed down like heirlooms — and habits, unlike genes, can be changed. This book breaks the cycle step by step: what to eat, how to move, and how to take back a body that was always yours to reclaim.",
  },
  {
    match: "silence divides",
    text: "The loudest force in any family, any workplace, any nation is not anger — it is silence. The conversations we refuse to have become the walls we cannot climb. This book is about finding your voice before the silence decides for you.",
  },
  {
    match: "charm of music",
    text: "Before we had words, we had rhythm. Music is the oldest language of the human heart — it carries grief, joy, memory, and hope in a way nothing else can. In these pages we explore why a simple melody can change a mood, heal a wound, and bring strangers together as family.",
  },
];

export function findExcerpt(title = "") {
  const t = title.toLowerCase();
  const hit = EXCERPTS.find((e) => t.includes(e.match));
  return hit ? hit.text : null;
}
